// Cleaning person names on the way into Firestore.
//
// Registration wrote whatever the text field held, so a trailing space typed
// (or pasted) by a parent became part of the name forever: 22 athlete records
// carried one before the 2026-08-25 backfill — about one in eight. Nothing
// downstream trims, so those names sorted oddly and rendered with a visible
// gap ("Norah  Blackston" when first and last were joined).
//
// Collapsing internal runs as well as trimming the ends is deliberate: a
// double space inside a name is never intentional either, and joining first
// and last is exactly where it shows.

/** Trim a name field and collapse internal whitespace runs to one space. */
export const cleanName = (v) => String(v ?? '').replace(/\s+/g, ' ').trim();

/**
 * The person-name fields carried on user and athlete docs.
 *
 * Kept in one place because the edit screens save by spreading a whole form
 * object, so they clean by field list rather than field by field.
 */
export const NAME_FIELDS = [
  'firstName', 'lastName', 'nickname', 'preferredName',
  'guardian2FirstName', 'guardian2LastName',
];

/**
 * A copy of `obj` with any name field it already carries cleaned.
 *
 * Only touches keys that are present and hold strings — these objects are
 * written with merge/updateDoc, so adding a missing key would blank a field
 * the form never showed.
 */
export const cleanNames = (obj, fields = NAME_FIELDS) => {
  const out = { ...obj };
  for (const f of fields) {
    if (typeof out[f] === 'string') out[f] = cleanName(out[f]);
  }
  return out;
};
